import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { catalogColors } from './catalogColors';

export interface Segment {
  label: string;
  count: number;
  color: string;
  tooltip?: string;
}

interface SegmentedBarProps {
  segments: Segment[];
  total: number;
  height?: number;
  className?: string;
}

export function SegmentedBar({ segments, total, height = 24, className }: SegmentedBarProps) {
  const nonZero = segments.filter(s => s.count > 0);

  if (total === 0 || nonZero.length === 0) {
    return (
      <div
        className={`rounded overflow-hidden border ${className ?? ''}`}
        style={{ height, backgroundColor: 'white', borderColor: catalogColors.muted }}
      />
    );
  }

  return (
    <TooltipProvider>
      <div
        className={`flex rounded overflow-hidden ${className ?? ''}`}
        style={{ height }}
      >
        {nonZero.map((seg, i) => {
          const pct = (seg.count / total) * 100;
          return (
            <Tooltip key={i}>
              <TooltipTrigger asChild>
                <div
                  style={{ width: `${pct}%`, backgroundColor: seg.color, minWidth: pct > 0 ? 2 : 0 }}
                  className="transition-all"
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-xs font-medium">{seg.tooltip ?? `${seg.label}: ${seg.count.toLocaleString()}`}</p>
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
